import {Component, OnInit, ViewChild} from '@angular/core';
import {AcDialogService} from 'ac-infra';
import {SecurityPoliciesDialogComponent} from './security-policies-dialog/security-policies-dialog.component';
import {SecurityPoliciesApiService} from '../../../services/api/settings/administration/security-policies/security-policies-api.service';
import {ArmTableComponent} from '../../../components/arm-table/arm-table.component';
import {DefaultSecurityPoliciesPipe} from './default-security-policies.pipe';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import * as _ from 'lodash';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {RolesDisplayPipe} from './roles-display.pipe';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';

@Component({
  selector: 'security-policies',
  templateUrl: './security-policies.component.html',
  styleUrls: ['./security-policies.component.scss']
})
export class SecurityPoliciesComponent implements OnInit {
  searchData: any;
  searchTerms: any;
  selection: any;
  items: any;
  roles: any;
  filter;
  canSubmit: boolean;

  displayedColumns: any[] = [
    {name: 'name', display: 'Name', transformer: DefaultSecurityPoliciesPipe, selected: true, width: 200},
    {name: 'roles', display: 'Roles', transformer: RolesDisplayPipe, selected: true, width: 300},
    {name: 'ldapMapping', display: 'LDAP Mapping', selected: true, width: 150},
    {name: 'openLdapMapping', display: 'Open LDAP Mapping', selected: true, width: 150},
    {name: 'azureMapping', display: 'Azure Mapping', selected: true, width: 150},
    {name: 'radiusMapping', display: 'Radius Mapping', selected: true, width: 150}
  ];

  @ViewChild(ArmTableComponent) armTable;

  constructor(public dialog: MatDialog,
              private acDialogService: AcDialogService,
              private loaderService: LoaderService,
              private snackBarService: SnackBarService,
              private securityPoliciesApiService: SecurityPoliciesApiService,
              private userPrivilege: UserPrivilegeService) { }

  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.refresh();

    this.securityPoliciesApiService.getSecurityRoles().subscribe(roles => {
      this.roles = roles;
    });
  }

  addItem(): void {
    const dialogData: any = {
      isEditMode: false,
      selectedItem: {
        roles: ['MONITOR']
      },
      roles: this.roles
    };

    this.acDialogService.open(SecurityPoliciesDialogComponent, {
      dialogData,
      onSubmit: () => {
        this.securityPoliciesApiService.addSecurityPolicy(dialogData.selectedItem).subscribe(() => {
          this.snackBarService.display(`"${dialogData.selectedItem.name}" successfully added`);
          this.refresh();
        });
      },
      title: 'Add Security Policy'
    });
  }

  editItem(): void {
    const originalName = this.selection.name;
    const dialogData = {
      isEditMode: true,
      selectedItem: _.cloneDeep(this.selection),
      roles: this.roles
    };

    this.acDialogService.open(SecurityPoliciesDialogComponent, {
      dialogData,
      onSubmit: () => {
        this.securityPoliciesApiService.updateSecurityPolicy(dialogData.selectedItem).subscribe(() => {
          this.snackBarService.display(`"${originalName}" successfully edited`);
          this.refresh();
        });
      },
      title: 'Edit Security Policy'
    });
  }

  removeItem(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `Are you sure you want to delete "${this.selection.name}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(result => {
      this.securityPoliciesApiService.deleteSecurityPolicy(this.selection.id).subscribe(() => {
        this.snackBarService.display(`${this.selection.name} successfully deleted`);
        this.refresh();
        dialogRef.close();
      });
    });
  }

  refresh(): void {
    this.loaderService.showMainContainer();
    this.securityPoliciesApiService.getSecurityPolicies().subscribe(items => {
      this.items = items;
      this.loaderService.hideMainContainer();
    }, (error => {
      this.loaderService.hideMainContainer();
    }));
  }

  onSelection(selection: any): void {
    this.selection = selection;
  }

  onFilter(filter: any): void {
    this.armTable.firstPage();
    this.filter = filter;
  }
}
